const deviceDataMapping = (data = {}) => {
    const {
        dusn: serialNumber,
        codentify,
        communication_interface: connectionType,
        router_id: routerId,
        last_visit_ts: lastVisit,
        connection_ts: lastConnection,
        onboarding_status: onboardingStatus,
        user,
        holder,
        asset_id: assetId,
        ...rest
    } = data;

    const {experience_score_status: experienceStatus, ...restHolder} = holder || {};

    const {user_id: userId, is_convarsionable: isConversionable} = user || {};

    const holderData = restHolder && {
        assetId: restHolder?.asset_id,
        serialNumber: restHolder?.dusn,
        dusn: restHolder?.dusn,
        chargerSerialNumber: serialNumber,
        lastConnection,
        onboardingStatus,
    };

    return {
        assetId,
        dusn: serialNumber,
        serialNumber,
        codentify,
        connectionType,
        lastVisit,
        lastConnection,
        routerId,
        user,
        userId,
        onboardingStatus,
        holder: holderData,
        experienceStatus,
        isConversionable,
        ...rest,
    };
};

const authTokenMapping = (response) => response?.authToken;

export default {deviceDataMapping, authTokenMapping};
